import { Layout } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { FormUnsavedChangesWrapper } from 'components';

import { PROMIS_SECTIONS } from './promisSlice';

import { setFaqObject } from 'navigation/utils/navigationSlice';

import { OutcomeMeasuresHeader } from 'components/header';

import { cleanPagedQuestionnaireStorage } from 'features/patient/assessment/_utils/questionnaire-local-storage';
import { PaginationCombinedPromis } from './promis-pagination-combined';

export function PatientPromis() {
  const dispatch = useDispatch();
  const [currentSection, setSection] = useState(0);

  dispatch(
    setFaqObject({
      min: PROMIS_SECTIONS[currentSection].min,
      max: PROMIS_SECTIONS[currentSection].max,
      instructions: PROMIS_SECTIONS[currentSection].instructions,
      description: PROMIS_SECTIONS[currentSection].description
    })
  );

  return (
    <Layout style={{ backgroundColor: 'white' }}>
      <OutcomeMeasuresHeader
        label={'Exit'}
        title={`1st Questionnaire: ${
          PROMIS_SECTIONS[currentSection].title ?? `Section ${currentSection}`
        }`}
        onExit={() => {
          cleanPagedQuestionnaireStorage('questionnaire-promis');
        }}
      />
      <FormUnsavedChangesWrapper>
        {PROMIS_SECTIONS.length && (
          <PaginationCombinedPromis
            onSectionChange={page => setSection(page)}
            storageKey={'questionnaire-promis'}
          />
        )}
      </FormUnsavedChangesWrapper>
    </Layout>
  );
}
